import React from 'react'
import { IssuingListCardUser } from './issuingListCardUser'

export const IssuingListCardsUser = () => {
  return (
    <IssuingListCardUser />
  )
}
